export default class VideoHeroBg {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {}

  init() {}
}
